import base from "./base/index" // 接口域名列表
import axios from "../utils/http" // 导入http中创建的axios实例
import utils from "../utils"
import Cookie from "../utils/cookie"

import axiosBase from "axios"
/**
 * 文件资源
 */
const file = {
  /**
   * 拉取小文件
   */
  pullSmallFile(id) {
    return axios.post(
      base.file.pullSmallFile,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  /**
   * 上传小文件
   */
  pushSmallFile(fileName, remark, shared, fileType, data) {
    return axios.post(
      base.file.pushSmallFile,
      utils.postParamsArrayToJsonString({
        fileName,
        remark,
        shared,
        fileType,
        data
      })
    )
  },
  /**
   * 获取文件信息
   */
  getFilesInfo(userId, offset, limit) {
    return axios.post(
      base.file.getFilesInfo,
      utils.postParamsArrayToJsonString({ userId, offset, limit })
    )
  },
  /**
   * 删除文件资源
   */
  deleteSmallFile(id) {
    return axios.post(
      base.file.deleteSmallFile,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  /**
   * 拉取公司文件
   */
  pullCompanySmallFile(id) {
    return axios.post(
      base.file.pullCompanySmallFile,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  /**
   * 上传公司文件
   */
  pushCompanyFileToOss(companyId, fileName, remark, fileType, data) {
    return axios.post(
      base.file.pushCompanyFileToOss,
      utils.postParamsArrayToJsonString({
        companyId,
        fileName,
        remark,
        fileType,
        data
      })
    )
  },
  /**
   * 获取公司文件信息
   */
  getCompanyFilesInfo(companyId, offset, limit) {
    return axios.post(
      base.file.getCompanyFilesInfo,
      utils.postParamsArrayToJsonString({ companyId, offset, limit })
    )
  },
  /**
   * 删除公司文件资源
   */
  deleteCompanySmallFile(id) {
    return axios.post(
      base.file.deleteCompanySmallFile,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  listMeasureDocument(measureId) {
    return axios.post(
      base.file.listMeasureDocument,
      utils.postParamsArrayToJsonString({ measureId })
    )
  },
  uploadFile(params) {
    // 创建FormData对象
    let data = new FormData()
    // 将得到的文件流添加到FormData对象
    data.append("file", params.file)
    data.append("companyId", params.companyId)
    data.append("remark", params.remark)
    data.append("userHidden", params.userHidden)
    return axios.post("/api/uploadFile", data, {
      headers: {
        Authorization: Cookie.getToken(),
        "Content-Type": "multipart/form-data"
      }
    })
  },
  removePhotoForMeasure(id) {
    return axios.post(
      base.file.removePhotoForMeasure,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  /**
   * @description: OSS上传
   */
  ossUpload(file) {
    const data = new FormData()
    data.append("file", file)
    return new Promise(resolve => {
      axios
        .post(base.file.ossUpload, data, {
          headers: {
            Authorization: Cookie.getToken()
          }
        })
        .then(res => {
          const previewHost = "https://oss-wordorder-2.annengji.com.cn/"
          const downloadHost =
            "https://work-order-2.oss-cn-shenzhen.aliyuncs.com/"
          const url = downloadHost + res.data.location.replace("oss:", "")
          const urlList = url.split("/")
          res.data = {
            url,
            id: urlList[urlList.length - 1]
          }
          resolve(res)
        })
        .catch(err => {
          resolve(err)
        })
    })
  }
}

export default file
